import { VENDOR_TITLE_PREFIX, VENDOR_INDEX_ROUTE } from './consts';

export default () => ({
    label: VENDOR_TITLE_PREFIX,
    link: VENDOR_INDEX_ROUTE,
    icon: 'vendors',
    permission: 'vendors.index',
    order: 80,
});
